import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { ModalContext } from '../../context/ModalPortalContext';

const Modal = () => {
  let { modalTitle, modalContent, closeModal, modal, modalAction } = useContext(ModalContext);
  if (modal) {
    return ReactDOM.createPortal(
      <Dialog open={modal} onClose={closeModal} maxWidth="sm" fullWidth>
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>{modalContent}</DialogContent>
        {modalAction && (
          <DialogActions>
            <Button onClick={closeModal} variant="outlined">
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>,
      document.querySelector('#modal-root')
    );
  } else return null;
};

export default Modal;
